import styled from 'styled-components/macro';
import {
  blue,
  white,
  blueSecondary,
  graySecondaryDark,
} from '../../styles/colors';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';
import Icon from '../Icon';

export const RadioButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ alignLeft, description }) =>
    alignLeft || description ? 'flex-start' : 'center'};
  min-width: 25px;
  min-height: 25px;
  ${media.desktop`
    margin-bottom: 0;
  `}
`;

export const RadioButton = styled.div`
  border: 1px solid
    ${({ theme, invalid }) => (invalid ? theme.invalidColor : blue)};
  width: 25px;
  height: 25px;
  cursor: pointer;
  background-color: ${white};
  padding: 2px;
  margin-right: 18px;
  border-radius: 6px;
  text-align: center;
`;

export const Check = styled.div`
  background-color: ${({ theme, invalid }) =>
    invalid ? theme.invalidColor : blueSecondary};
  min-width: 19px;
  min-height: 19px;
  border-radius: 6px;
`;

export const StyledLabel = styled.div`
  display: flex;
  flex-direction: row;
  ${fontSize(12)};
  color: ${({ dark }) => (dark ? graySecondaryDark : blueSecondary)};
${({ theme, invalid }) => invalid && `color: ${theme.invalidColor};`}
  font-weight: ${({ bold }) => bold && 'bold'};
  cursor: pointer;
  ${media.desktop`
    ${fontSize(14)}
  `}
  > span {
    margin-top: 8px;
  }
`;

export const Description = styled.p`
  color: ${({ theme, invalid }) =>
    invalid ? theme.invalidColor : theme.colorText};
  ${fontSize(12)};
  margin-top: 10px;
  margin: 10px 10px 0 45px;
  line-height: 1.4;
  ${media.desktop`
    ${fontSize(14)}
  `}
`;

export const IconCheck = styled(Icon)`
  font-size: 20px;
  color: ${({ theme }) => theme.radioIconColor};
`;
